export default __webpack_public_path__ + "static/media/solidworks-register.5e94fa47.png";